import {Button} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

type Props = {
  title?: string;
  BackToScreen?: string | -1;
};

export default function BackButton(props: Props) {
  const {title, BackToScreen = -1} = props;
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(BackToScreen)}
      variant="text"
      style={styles.buttonStyle}
      color="inherit"
      startIcon={<ArrowBackIosIcon style={styles.buttonIconStyle} />}>
      {title}
    </Button>
  );
}

const styles = {
  buttonStyle: {
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 13,
    lineHeight: '150%',
    textTransform: 'none',
  },
  buttonIconStyle: {fontSize: 13},
};
